import { MatomoAnalytics, MatomoTagManagerAnalytics, NpsAnalytics } from '~libs.shared.analytics';

export const AppAnalytics = (): JSX.Element => {
   const { npsScriptLink, matomoScriptLink, matomoSiteId, matomoTagManagerContainerUrl } = window.APP_ENV;
   return (
      <>
         {npsScriptLink ? <NpsAnalytics scriptLink={npsScriptLink} /> : null}
         {matomoScriptLink && matomoSiteId ? (
            <MatomoAnalytics scriptLink={matomoScriptLink} sideId={matomoSiteId} />
         ) : null}
         {matomoTagManagerContainerUrl ? (
            <MatomoTagManagerAnalytics containerUrl={matomoTagManagerContainerUrl} />
         ) : null}
      </>
   );
};
